import { render } from "./PrefixSubZoneRestrictionsModal.vue?vue&type=template&id=0867af90"
import script from "./PrefixSubZoneRestrictionsModal.vue?vue&type=script&lang=js"
export * from "./PrefixSubZoneRestrictionsModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__